class CardNumberSignInController {
    static create(params) {
        return new CardNumberSignInController(params);
    }

    constructor({env}) {
        this.env = env;
        this.dialog = env.getDialog('user-sign-in-dialog');

        this.initEvents();
    }

    initEvents() {
        this.dialog.on('submitGesture', () => this.onSubmitGesture());
    }

    async onSubmitGesture() {
        var proxy = this.env.getProxy(),
            {cardNumber} = this.dialog.getState(),
            guestSectionActive = this.dialog.guestSectionActive(),
            cardNumberRequired = !guestSectionActive && !cardNumber;

        this.dialog.clearErrors();

        if (cardNumberRequired) {
            this.dialog.addCardNumberRequiredError();
            return;
        }

        try {
            this.dialog.setSubmitting(true);

            await (guestSectionActive ? proxy.authenticateGuest() : proxy.authenticateLibraryCardUser(cardNumber));

            this.dialog.getForm().submit();
        }
        catch (error) {
            this.dialog.setSubmitting(false);

            if (error.hasType('InvalidLibraryCardNumberFormat')) {
                this.dialog.addAccountSectionError('Please provide a valid library card number to sign in.');
            }
            else if (error.hasType('MaxConcurrentUsersExceeded')) {
                this.env.showDialog('user-limit-exceeded-dialog').then(() => this.dialog.show());
            }
            else {
                throw error;
            }
        }
    }

    show() {
        this.dialog.show();
        this.dialog.focusCardNumberField();
    }
}

export default CardNumberSignInController;